module.exports = __webpack_public_path__ + "static/SFCompactBold-9df966e9d466331a646e52bffdf671d4.woff2";